import { otpTokens, refreshTokens } from '../auth'
import { describeTable } from './describeTable'

describeTable(otpTokens, {
  description: 'Login one-time codes; not readable by the assistant.',
  aiAccess: 'denied',
})

describeTable(refreshTokens, {
  description: 'Login session refresh tokens; not readable by the assistant.',
  aiAccess: 'denied',
})
